import { ColumnInstance, MetaBase } from 'react-table'
import { ActionColumnProps } from '../Spectable.types'
/**
 * Plugin to add an action column at the end of the table.
 * This will always be sticky.
 */
const actionColumn = <TData extends Object>({
    Cell,
    width,
}: ActionColumnProps<TData>) => (
    columns: ColumnInstance<TData>[],
    _meta: MetaBase<TData>
) => {
    return [
        ...columns,
        {
            Header: '',
            id: 'actionCol',
            disableResizing: true,
            disableSortBy: true,
            disableFilters: true,
            sticky: 'right',
            stickyRightMargin: 0,
            width: width,
            minWidth: width,
            maxWidth: width,
            Cell,
        },
    ] as ColumnInstance<TData>[]
}

export default actionColumn
